import { render, staticRenderFns } from "./CoursewareStructuralElementDialogAdd.vue?vue&type=template&id=e82b560a&"
import script from "./CoursewareStructuralElementDialogAdd.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementDialogAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports